module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Miriam grew up in the bracing seaside town of Skegness. She inherited her love of story from her grandad, whose Christmas tradition was a glorious and giant sack full of books to dive into. Storytime evolved into a career as an actor; touring theatre, a tight-knit, fast-paced industry in which she was given the opportunity to write, direct and examine story from every angle. After an exhilarating decade, she left performance work to pursue her growing passion for creative writing, driving her adventure onwards to a Masters in Writing at Birmingham City University. And there, the idea for The Test sparked and a new chapter opened…")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0